import React, { useEffect, useState } from 'react';
import PopAdminPresenter from "@/presenters/screens/pop-admin.presenter";
import { SingleCollapse } from "@/components/";
import AEATitle from "@/components/ui/aea-title/aea-title";
import AEABatchGrid from '../../../../ui/aea-batch-grid/aea-batch-grid';
import Results from "../results/Results";
import SpecificObjetives from './SpecificObjetives';

export interface IPropsStep {
    columns: any,
    data: any,
}

const Objetives: React.FC<IPropsStep> = ({columns, data} : IPropsStep) => {
    const [dataColumns, setDataColumns] = useState<any>(null);
    const [showChildren, setShowChildren] = useState<any>(false);

    const view: any = {
        state: {
            columns,
            dataColumns,
            data,
        },
    };
      
    const presenter = new PopAdminPresenter(view);
    
    useEffect(() => {
        if(data && columns){
            let auxCol = presenter.getDataColumnsPpalObj(presenter.formMasters)
            setDataColumns(auxCol)
        }
    }, [data, columns])

    if(!data.genericInfo || !dataColumns) return <></>
    return (
        <div style={{margin: '20px 0'}}>
            <AEABatchGrid 
                dataSource={[data?.genericInfo]} 
                gridProps={{selection:{ mode: 'single' }}} 
                columns={dataColumns} readOnly={true} 
                onSelectionChanged={() => setShowChildren(true)} 
            ></AEABatchGrid>
            {showChildren &&
                <div style={{margin: '20px 0'}}>
                    <AEATitle
                        id={"proaFEObjetivosEspecíficos"}
                        text={presenter.currentLabels.get("proaFEObjetivosEspecíficos")}
                        tooltip={presenter.currentLabels.get("proaFEObjetivosEspecíficos")}
                        placement={"auto"}
                    ></AEATitle>
                    <SpecificObjetives columns={columns} data={data?.specificObjetives} />
                    <SingleCollapse
                        title={presenter.currentLabels.get("ResultadosEsperados")}
                        isOpen={false}
                    >
                        {!!data?.results &&
                            data.results?.map((res: any) => {
                                return (
                                    <Results columns={columns} data={res} key={res.genericInfo.Id} />
                                );
                            })
                        }
                    </SingleCollapse>
                </div>
            }
        </div>
    )
}

export default Objetives;